// @flow
import * as React from 'react';

import ReactDOM from 'react-dom';
import InlineIntegrationChecker from './components/InlineIntegrationChecker';
import IntegrationCheckerDataFetcher from './IntegrationCheckerDataFetcher';
import IntegrationCheckerRunner from './data/IntegrationCheckerRunner';

import type {GlobalsProps} from './index';

const renderInlineChecker = (
  runner: IntegrationCheckerRunner,
  checkerScenario: string,
  checkerTestCase: string,
  element: HTMLElement,
  globals: GlobalsProps,
) => {
  const {dashboardUrl} = globals;
  ReactDOM.render(
    <IntegrationCheckerDataFetcher
      globals={globals}
      runner={runner}
      startPolling
    >
      {({runCheckerResult}) => {
        const {results} = runCheckerResult;
        const scenario = results.find((result) => {
          return result.type === checkerScenario;
        });

        if (!scenario) {
          return null;
        }

        const check = scenario.checks.find(
          (checker) => checker.name === checkerTestCase,
        );

        if (!check) {
          return null;
        }

        return (
          <InlineIntegrationChecker
            check={check}
            paymentIntentId={scenario.target_object_id}
            dashboardUrl={dashboardUrl}
          />
        );
      }}
    </IntegrationCheckerDataFetcher>,
    element,
  );
};

export default renderInlineChecker;
